import React, {} from 'react'
import {Redirect} from 'react-router-dom'

const Partner = () => <Redirect to={'/partner/usestatus/usedetail'}/>;

export default Partner;
